import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export interface ExpenseTag {
  id: string;
  name: string;
  color: string;
  created_at: string;
  updated_at: string;
}

export const useExpenseTags = () => {
  return useQuery({
    queryKey: ["expense-tags"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("expense_tags")
        .select("*")
        .order("name", { ascending: true });

      if (error) {
        throw error;
      }

      return data as ExpenseTag[];
    },
  });
};

export const useCreateExpenseTag = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (tag: { name: string; color: string }) => {
      const { data, error } = await supabase
        .from("expense_tags")
        .insert([tag])
        .select()
        .single();

      if (error) {
        throw error;
      }

      return data as ExpenseTag;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["expense-tags"] });
      queryClient.invalidateQueries({ queryKey: ["expenses"] });
      toast({
        title: "Etiqueta creada",
        description: "La etiqueta se ha creado correctamente",
      });
    },
    onError: (error: Error) => {
      toast({
        title: "Error al crear etiqueta",
        description: error.message,
        variant: "destructive",
      });
    },
  });
};
